import React, { useState, useEffect } from 'react';

const LoadingSpinner = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress < 100) return prevProgress + 10;
        clearInterval(interval);
        return 100;
      });
    }, 40);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 bg-gradient-to-r from-purple-500 to-purple-300 flex justify-center items-center z-50">
      <div className="flex flex-col items-center space-y-4">
        <div className="text-yellow-400 font-bold text-3xl animate-shine" style={{ fontFamily: 'Bangers, cursive' }}>Prepify</div>
        <div className="w-2/3 sm:w-3/4 bg-white rounded-full h-4 overflow-hidden">
          <div
            className="bg-green-500 h-full transition-width duration-1000 ease-in-out"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;